import { Link } from 'react-router-dom';
import { company, navigation } from '@/data/company';
import { SocialIcon } from './SocialIcon';

export function Footer() {
  return (
    <footer className="border-t border-border bg-footer text-footer-text">
      <div className="site-container py-12 sm:py-16">
        <div className="grid gap-10 md:grid-cols-[1.35fr_0.65fr_1fr] md:gap-8">
          <div className="max-w-md">
            <Link
              to="/"
              className="inline-flex items-center gap-2.5"
              aria-label="Helmflex početna"
            >
              <span className="grid size-9 place-items-center rounded-[var(--radius-sm)] bg-primary text-sm font-bold text-on-primary">
                H
              </span>
              <span className="text-lg font-bold text-white">helmflex</span>
            </Link>
            <p className="mt-5 text-sm leading-6 text-footer-muted">
              {company.description} Za svaki angažman definišemo obim, odgovorne
              osobe i način izveštavanja.
            </p>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-white">Navigacija</h2>
            <ul className="mt-4 space-y-3">
              {navigation.map(item => (
                <li key={item.to}>
                  <Link
                    className="animated-link inline-block text-sm text-footer-muted transition-colors hover:text-primary"
                    to={item.to}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-white">Kontakt</h2>
            <address className="mt-4 space-y-3 text-sm not-italic text-footer-muted">
              <p>{company.address}</p>
              <a
                className="animated-link inline-block transition-colors hover:text-primary"
                href={`mailto:${company.email}`}
              >
                {company.email}
              </a>
              <a
                className="animated-link inline-block transition-colors hover:text-primary"
                href={`tel:${company.phoneHref}`}
              >
                {company.phone}
              </a>
            </address>
            <div className="mt-5 flex gap-2">
              {[
                {
                  link: company.socials.facebook,
                  network: 'facebook' as const
                },
                {
                  link: company.socials.instagram,
                  network: 'instagram' as const
                },
                { link: company.socials.linkedin, network: 'linkedin' as const }
              ].map(({ link, network }) => (
                <a
                  key={link.label}
                  className="grid size-10 place-items-center rounded-full border border-white/12 text-footer-muted transition-colors hover:border-primary hover:text-primary focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-primary/30"
                  href={link.url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={link.label}
                >
                  <SocialIcon network={network} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-footer-muted sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {new Date().getFullYear()} {company.name}. Sva prava zadržana.
          </p>
          <Link
            className="animated-link transition-colors hover:text-primary"
            to="/kontakt#politika-privatnosti"
          >
            Politika privatnosti
          </Link>
        </div>
      </div>
    </footer>
  );
}
